import keyBy from 'lodash/keyBy';

import { DatabaseFieldEditorConfig } from '@/modules/corporate/modules/database/fields/types';

import * as FieldUtils from '../../utils/editor/config';
import { fieldSettingsSectionStyles } from '../../utils/editor/styles';

const CheckboxFieldEditorConfig: DatabaseFieldEditorConfig = {
  getFieldSettingsFormProps: ({ t, allowPartialUpdates }) => {
    const fields = [
      FieldUtils.getDatabaseTypeFormField(t, allowPartialUpdates),
      FieldUtils.getRequiredFormField(t),
      FieldUtils.getDescriptionEnabledFormField(t),
    ];

    return {
      fields: keyBy(fields, 'name'),
      sectionLayout: [
        {
          id: 'checkbox-settings',
          className: fieldSettingsSectionStyles(24),
          layout: ['metadataField.type', 'viewField.required', 'viewField.descriptionEnabled'],
        },
      ],
      overrides: FieldUtils.FormOverrides,
    };
  },
  getFieldSettingsFormInitialValues: ({ metadataField, viewField }) => ({
    metadataField: { type: metadataField.type },
    viewField: { required: viewField.required, descriptionEnabled: viewField.descriptionEnabled },
  }),
  adaptEditorFormField: () => ({ props: { defaultChecked: true } }),
};

export default CheckboxFieldEditorConfig;
